import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, withCtx as _withCtx, createSlots as _createSlots, openBlock as _openBlock, createBlock as _createBlock, mergeProps as _mergeProps, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "masthead" }


import TitleBar, { TitleBarProps } from '@shell/components/Resource/Detail/TitleBar/index.vue';
import Metadata, { MetadataProps } from '@shell/components/Resource/Detail/Metadata/index.vue';
import Cards from '@shell/components/Resource/Detail/Cards.vue';

export interface MastheadProps {
  titleBarProps?: TitleBarProps;
  metadataProps?: MetadataProps;
}

export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    titleBarProps: {},
    metadataProps: {}
  },
  setup(__props: any) {

const props = __props;


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (props.titleBarProps)
      ? (_openBlock(), _createBlock(TitleBar, _normalizeProps(_mergeProps({ key: 0 }, props.titleBarProps)), _createSlots({ _: 2 }, [
          (_ctx.$slots['additional-actions'])
            ? {
                name: "additional-actions",
                fn: _withCtx(() => [
                  _renderSlot(_ctx.$slots, "additional-actions")
                ]),
                key: "0"
              }
            : undefined
        ]), 1040))
      : _createCommentVNode("", true),
    _cache[0] || (_cache[0] = _createTextVNode()),
    (props.metadataProps)
      ? (_openBlock(), _createBlock(Metadata, _mergeProps({
          key: 1,
          class: "metadata-section"
        }, props.metadataProps), null, 16))
      : _createCommentVNode("", true),
    _cache[1] || (_cache[1] = _createTextVNode()),
    (props.titleBarProps)
      ? (_openBlock(), _createBlock(Cards, {
          key: 2,
          class: "cards-section",
          resource: props.titleBarProps.resource
        }, null, 8, ["resource"]))
      : _createCommentVNode("", true)
  ]))
}
}

})